import { useMsal } from '@azure/msal-react';

export interface EntraIdentity {
  email: string;
  name: string;
  initials: string;
}

/** Reads the active MSAL account's claims. Returns null when not signed in. */
export function useEntraIdentity(): EntraIdentity | null {
  const { instance } = useMsal();
  const account = instance.getActiveAccount() ?? instance.getAllAccounts()[0] ?? null;
  if (!account) return null;
  const email = (account.username ?? '').toLowerCase();
  const name = account.name ?? account.username ?? email;
  return { email, name, initials: initialsOf(name) };
}

function initialsOf(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0]!.slice(0, 2).toUpperCase();
  return (parts[0]![0]! + parts[parts.length - 1]![0]!).toUpperCase();
}
